<ng-container *ngIf="data">
  <div [innerHTML]="data | sanitizeHtml" headerScripts></div>
</ng-container>
